import { IApplicationState } from '../../types/redux';

/**
 * Выбирает состояние подобных статьей
 */
export const selectSimilarArticlesStatus = ({ similarArticles }: IApplicationState) => similarArticles.status;
